import { NavLink, useNavigate, Link } from "react-router-dom";
import {
  LayoutDashboard, Briefcase, Plus, Wallet, Bell, User, LogOut, Settings, Receipt, FileText, FileSearch, X
} from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/app/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/app/jobs", label: "Jobs", icon: Briefcase },
  { to: "/app/jobs/new", label: "New Job", icon: Plus, primary: true },
  { to: "/app/reports", label: "Your Reports", icon: FileText },
  { to: "/app/sample-reports", label: "Sample Reports", icon: FileSearch },
  { to: "/app/credits", label: "Credits", icon: Wallet },
  { to: "/app/billing", label: "Billing", icon: Receipt },
  { to: "/app/notifications", label: "Notifications", icon: Bell },
  { to: "/app/profile", label: "Profile", icon: User },
  { to: "/app/settings", label: "Settings", icon: Settings },
];

export default function AppSidebar({
  open,
  onClose,
}) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    onClose?.();
    logout();
    navigate("/");
  };

  return (
    <>
      {/* Mobile Backdrop */}
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`
      fixed top-0 left-0 z-50 h-screen w-64
      bg-white border-r border-[#E5E7EB]
      flex flex-col
      transform transition-transform duration-300
      ${open ? "translate-x-0" : "-translate-x-full"}
      lg:translate-x-0
    `}
      >
        <div className="h-16 border-b border-[#E5E7EB] px-5 flex items-center justify-between">
          <a
            href="https://bioinfo.bionivid.in"
            onClick={onClose}
            className="cursor-pointer"
          >
            <Logo version="v2.0" />
          </a>

          <button
            onClick={onClose}
            className="rounded-md p-2 text-gray-600 hover:bg-gray-100 lg:hidden"
            aria-label="Close menu"
          >
            <X size={20} />
          </button>
        </div>
        <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                onClick={onClose}
                data-testid={`sidebar-${it.to.split("/").pop()}`}
                className={({ isActive }) =>
                  `group flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${isActive
                    ? "bg-[#0B6936] text-white"
                    : "text-gray-600 hover:bg-[#0B6936]/10 hover:text-[#0B6936]"
                  }`
                }
                end={it.to === "/app/dashboard" || it.to === "/app/jobs"}
              >
                <Icon size={18} strokeWidth={1.75} />
                <span>{it.label}</span>
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-[#E5E7EB]">
          <div className="px-3 py-2 mb-2">
            <div className="text-sm font-semibold text-gray-900 truncate">{user?.full_name}</div>
            <div className="text-xs text-gray-500 truncate">{user?.email}</div>
          </div>
          <button
            onClick={doLogout}
            data-testid="app-logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900"
          >
            <LogOut size={16} strokeWidth={1.75} />
            Log out
          </button>
        </div>
      </aside>
    </>
  );
}
